<template>
  <v-main>
    <header-components></header-components>
    <title-components></title-components>
    <v-container
      class="mx-auto mt-6"
      style="max-width: 1200px;"
    >
      <progress-components page="result"></progress-components>
      <v-row justify="center" class="mb-8 my-6">
        <div class="text-body-1" style="font-weight: bold;">ご回答ありがとうございました</div>
      </v-row>
    </v-container>
    <footer-components></footer-components>
  </v-main>
</template>
<script>
import { defineComponent } from 'vue'
import { Logger } from 'aws-amplify'
import HeaderComponents from '@/components/InterviewHeader.vue'
import FooterComponents from '@/components/InterviewFooter.vue'
import TitleComponents from '@/components/InterviewTitle.vue'
import ProgressComponents from '@/components/InterviewProgress.vue'

const logger = new Logger('AdvanceForm');

export default defineComponent({
  components: {
    'header-components': HeaderComponents,
    'footer-components': FooterComponents,
    'title-components': TitleComponents,
    'progress-components': ProgressComponents
  },
  setup() {
    logger.info('Advance done')
  }
})
</script>
